import type { TableChangesStorage } from '@/shared/components/data-grid/helpers'
import type { FieldSchemaModel } from '@/shared/generated'
import type { FieldCellProps, FieldsRegistry } from './fields'

import React from 'react'
import { Slot } from 'radix-ui'

import { useTableChangesField } from '@/shared/components/data-grid/helpers'

export default function BasicEditableField({
	control,
	value,
	children,
	...props
}: {
	row: any
	value?: any
	field: FieldSchemaModel
	control: TableChangesStorage
	children: React.ReactNode
} & FieldCellProps<keyof FieldsRegistry>) {
	const fieldProps = useTableChangesField({
		control,
		name: props.field.id,
		defaultValue: value,
		row: props.row,
	})

	return (
		<Slot.Root {...props} {...fieldProps}>
			{children}
		</Slot.Root>
	)
}
